import colors from '../colors';
import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import * as SadFace from 'react-icons/lib/md/mood-bad';
import * as NeutralFace from 'react-icons/lib/md/sentiment-neutral';
import * as HappyFace from 'react-icons/lib/md/mood';

export interface BaseProps {
    avatar: string;
    name: string;
    setSurveyScore: (score: number) => void;
    removeConversation: (hide?: boolean) => void;
    hasLinks: boolean;
}

export interface BaseState {}

export default class BaseSurvey<
    Props extends BaseProps,
    State extends BaseState
> extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleFaceClick = this.handleFaceClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    handleFaceClick(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        e.stopPropagation();

        const score = Number(e.currentTarget.dataset.value);

        this.props.setSurveyScore(score);

        const shouldHide = !this.props.hasLinks;
        this.props.removeConversation(shouldHide);
    }

    handleCloseClick(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.props.removeConversation();
    }

    renderFaces() {
        return (
            <FaceWrapper className="conversations-survey">
                <Face
                    className="conversations-survey-value conversations-survey-value-01"
                    href="#"
                    selectedColor={colors.red}
                    data-value="1"
                    onClick={this.handleFaceClick}
                >
                    <SadFace size={80} />
                </Face>
                <Face
                    className="conversations-survey-value conversations-survey-value-03"
                    href="#"
                    selectedColor="#FB7B24"
                    data-value="3"
                    onClick={this.handleFaceClick}
                >
                    <NeutralFace size={80} />
                </Face>
                <Face
                    className="conversations-survey-value conversations-survey-value-05"
                    href="#"
                    selectedColor={colors.green}
                    data-value="5"
                    onClick={this.handleFaceClick}
                >
                    <HappyFace size={80} />
                </Face>
            </FaceWrapper>
        );
    }
}

const FaceWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
`;

const a: StyledFunction<any & React.HTMLProps<HTMLInputElement>> = styled.a;
const Face = a`
    display: block;
    padding: 0 5px;
    transition: all 0.2s;
    color: ${props => (props.selected ? props.selectedColor : colors.mediumDarkGray)};
    transform: scale(${props => (props.selected ? 1.1 : 1)});
    &:hover {
    transform: scale(1.1);
    svg {
        color: ${props => props.selectedColor};
    }
}
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/BaseSurvey.tsx